import { baseTransverse } from './transverse';

export const getProduitsJvs = ({ page } = { page: 1 }) => `${baseTransverse}/produits?page=${page}`;
